import React, { useState } from 'react';
import CustomInput from "../../components/UI/customInput/customInput";
import CustomButton from "../../components/UI/customButton/customButton";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../components/UI/customSelect/customSelect";
import CityTable from "../../components/table/city-table";
import ShipTable from "../../components/table/ship-table";
import { Post } from "../../apis/api";
import { toast } from "react-toastify";
import Upload from "../../components/UI/upload/upload";
import { useSelector } from 'react-redux';
import { useShipTypes } from './ShipTypes/hooks';

const ShipSection = () => {
  const [form, setForm] = useState({})
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [editId, setEditId] = useState(null)
  const [clear, setClear] = useState(false)
  const getBaseApi = () => process.env.REACT_APP_PUBLIC_URL;
  const countryList = useSelector((state) => state.setting.country)

  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }))
  }

  const { data: shipTypeData } = useShipTypes()

  const handleSubmit = () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("form", editId ? "update_form" : "store_form");

    const { file , ...restForm} = form

    Object.keys({ ...restForm, ...(typeof file == 'object' && !!file ? { file } : {}) }).forEach(key => {
      formData.append(key, form[key]);
    });

    Post(`basic-information/ship/${editId ? `update/${editId}` : "store"}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((res) => {
        toast.success(res.msg);
        setData(res?.details?.data);
        setOpen(false);
      })
      .catch((error) => {
        toast.error(error.data.message || error.data.msg)
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleEdite = (e) => {
    setOpen(true)
    setClear(false)
    setForm({ "imo": e["imo"], "owner": e["owner"], "name": e["name"], "file": e["filepath"], country_id: e["country_id"], ship_type_id: e["ship_type"]?.id })
    setEditId(e.id)
  }
  const handleClose = () => {
    setOpen(false)
    setForm({})
    setClear(true)

    setEditId(null)
  }

  const handleCountry = (id) => {
    return countryList?.find((item => {
      return (
        item.id === id
      )
    }))
  }


  const handleShipType = (id) => {
    return shipTypeData?.details?.data?.data?.find((item => {
      return (
        item.id === id
      )
    }))
  }

  const { t } = useTranslation();

  console.log({ countryList, shipTypeData })

  return (
    <div className={"flex flex-col w-full pb-32"}>
      <div onClick={(e) => e.target === e.currentTarget && handleClose()} className={`fixed top-0 right-0 bg-modal h-full w-full z-50 flex justify-center items-center ${open ? "flex" : "hidden"}`}>
        <div className={" bg-white rounded-lg p-5 flex flex-col items-center max-w-[350px]"}>
          <div className={"text-gray-500 text-base"}>
            {t("titleShip")}
          </div>
          <div className={"flex mt-5 justify-between gap-5 w-full"}>
            <span className={"w-full"}>
              <CustomInput
                placeHolder={t("shipNameFa")}
                label={t("shipNameFa")}
                name={"name"}
                defaultValue={form["name"]}
                onchange={(e) => handleForm(e)}
              />
            </span>
          </div>
          <div className={"grid grid-cols-1  mt-5 justify-between gap-5 w-full"}>
            <CustomInput
              placeHolder={"IMO"}
              label={"IMO"}
              name={"imo"}
              defaultValue={form["imo"]}
              onchange={(e) => handleForm(e)}
            />
            <CustomInput
              placeHolder={t("ownership")}
              label={t("ownership")}
              name={"owner"}
              defaultValue={form["owner"]}
              onchange={(e) => handleForm(e)}
            />

            <CustomSelect
              name="country_id"
              label={t("flag")}
              options={countryList}
              defaultValue={handleCountry(form["country_id"])}
              onchange={(e) => handleForm(e)}
            />


            {!!shipTypeData?.details?.data && <CustomSelect
              name="ship_type_id"
              label={t("shipType")}
              options={shipTypeData?.details?.data?.data}
              defaultValue={handleShipType(form["ship_type_id"])}
              onchange={(e) => handleForm(e)}
              hideSearch
            />}

            <Upload onClear={clear} defaultValue={typeof form?.file === "string" && form?.file?.replace("storage", "/")} onChange={(e) => handleForm({ name: e.name, value: e.value })} title={t("documents")} name={"file"} />


            <CustomButton loading={loading} onClick={handleSubmit} title={t("save")} />
          </div>
        </div>
      </div>
      <div className={"flex justify-end gap-5 w-full my-container"}>
        <div className={"w-[207px]"}>
          <CustomButton onClick={() => setOpen(true)} title={t("newShip")} />
        </div>
      </div>
      <div>
        <ShipTable onClear={() => setClear(true)} onClose={() => handleClose()} defaultValue={data} editItem={(e) => handleEdite(e)} />
      </div>
    </div>
  );
};

export default ShipSection;
